<template>
  <div>
    <v-dialog v-model="dialog" persistent scrollable max-width="500">
      <v-card class="orange lighten-4">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 my-4">
            <p style="text-align: justify">
              &nbsp;
              {{ msg }}
            </p>
          </div>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="no()"> No </v-btn>
          <v-btn
            color="green"
            :loading="setLoading"
            :disabled="setLoading"
            class="white--text"
            @click="yes()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    msg: null,
  },
  components: {},
  data() {
    return {
      dialog: false,
      setLoading: false,
    };
  },
  watch: {
    msg: {
      handler(data) {
        if (data) {
          this.dialog = true;
        } else {
          this.dialog = false;
          this.setLoading = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    yes() {
      this.$emit("yes", true);
      this.setLoading = true;
      // if (this.loading == false) this.dialog = false;
    },
    no() {
      this.$emit("no", false);
      this.dialog = false;
    },
  },
};
</script>
